define([], function () {
    function config($stateProvider) {
        $stateProvider
            .state("app.project", {
                abstract: true,
                url: "/project/",
                templateUrl: './app/modules/project/project.html',
                resolve: {
                    notVerifiedRedirect: ['UserService', 'AuthService', '$state', function (UserService, AuthService, $state) {
                        return UserService.sessionInfo()
                            .then(function (res) {
                                var user = AuthService.getSessionUser();
                                if (res && res.data && res.data.isActive === false && user && user.email) {
                                    $state.go('access.email-verification', {
                                        token: btoa(user.email)
                                    });
                                }
                            })
                            .catch(function (err) {
                                console.log(err);
                            });
                    }],
                }
            })
            /* Keep the wizard before the generic /:projectId route, otherwise
               /project/wizard/:step is interpreted as a project workspace. */
            .state("app.project.wizard", {
                url: "wizard/:step?:firstproject&:from&:url&:fresh",
                params: {
                    step: {
                        value: 'create-project',
                        squash: true
                    }
                },
                controller: 'ProjectWizardCtrl',
                templateUrl: './app/modules/project/wizard/wizard.html',
            })
            .state("app.project.detail", {
                abstract: true,
                url: ":projectId/",
                controller: 'ProjectWorkspaceCtrl',
                templateUrl: './app/modules/project/workspace/workspace.html',
                access: {restricted: true},
            })
            .state("app.project.detail.overview", {
                url: "overview",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/overview.html',
                access: {restricted: true},
            })
            .state("app.project.detail.log", {
                url: "scan-log",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/scan-log.html',
                access: {restricted: true},
            })
            .state("app.project.detail.tracker", {
                url: "rank-tracker",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/tracker.html',
                access: {restricted: true},
            })
            .state("app.project.detail.report", {
                url: "seo-report?section",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/report.html',
                access: {restricted: true},
            })
            .state("app.project.detail.issues", {
                url: "issues",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/issues.html',
                access: {restricted: true},
            })
            .state("app.project.detail.spider", {
                url: "seo-spider?category&variant",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/spider.html',
                access: {restricted: true},
            })
            .state("app.project.detail.explorer", {
                url: "page-explorer?filter",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/explorer.html',
                access: {restricted: true},
            })
            .state("app.project.detail.links", {
                url: "link-explorer?filter",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/link-explorer.html',
                access: {restricted: true},
            })
            .state("app.project.detail.export", {
                url: "bulk-export",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/bulk-export.html',
                access: {restricted: true},
            })
            .state("app.project.detail.structure", {
                url: "structure-explorer",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/structure-explorer.html',
                access: {restricted: true},
            })
            .state("app.project.detail.crux", {
                url: "crux",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/crux.html',
                access: {restricted: true},
            })
            .state("app.project.detail.aeo", {
                url: "aeo",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/aeo.html',
                access: {restricted: true},
            })
            .state("app.project.detail.traffic", {
                url: "traffic",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/traffic.html',
                access: {restricted: true},
            })
            .state("app.project.detail.searchConsole", {
                url: "search-console?view",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/search-console.html',
                access: {restricted: true},
            })
            .state("app.project.detail.sitemaps", {
                url: "sitemaps",
                controller: 'ProjectWorkspaceSectionCtrl',
                templateUrl: './app/modules/project/workspace/sitemaps.html',
                access: {restricted: true},
            })
            .state("app.project.settings", {
                url: ":projectId/settings/:activeTab?fromTool&addKeyword",
                controller: 'SettingsCtrl',
                templateUrl: './app/modules/project/settings/settings.html',
                access: {restricted: true},
                resolve: {
                    settings: ['$stateParams', 'ProjectsService', '$state',
                        function ($stateParams, ProjectsService, $state) {
                            return ProjectsService.getSettings($stateParams.projectId)
                                .then(function (res) {
                                    if (!res || !res.data || !res.data.settings) {
                                        $state.go('app.project.wizard', {step: 'create-project'});
                                        return;
                                    }

                                    return res.data.settings;
                                })
                                .catch(function (err) {
                                    $state.go('app.project.wizard', {step: 'create-project'});

                                    console.log(err);
                                    return err.data;
                                });
                        }],
                },
            });
    }

    config.$inject = ['$stateProvider'];
    return config;
});
